export const LogInPaths = {
  company: '/company',
  selector: '/company/selector',
  signIn: '/company/sign-in',
  cbidpExchange: '/cbidp-exchange',
  logout: '/logout',
  invite: '/company/invite',
};

// Cognito self-serve auth pages removed in GRW-2782. These old URLs are kept
// only so both routers can redirect direct hits to a clean entry point instead
// of leaking the removed URL (and any tmp password) into a redirectUri or being
// misread as a company key.
export const REMOVED_SELF_SERVE_PATHS = [
  '/company/sign-up',
  '/company/verify',
  '/company/reset-password',
  '/company/forgot-password',
  '/company/mfa-reset-password',
];
